import { render, staticRenderFns } from "./ExamInfo.vue?vue&type=template&id=d8fc23d8&scoped=true"
import script from "./ExamInfo.vue?vue&type=script&lang=js"
export * from "./ExamInfo.vue?vue&type=script&lang=js"
import style0 from "./ExamInfo.vue?vue&type=style&index=0&id=d8fc23d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fc23d8",
  null
  
)

export default component.exports